// add 1 to display points written to overflow file
export const NUM_INUNDATION_BOUNDARY_LAYERS = 4 + 1;
export const NUM_INUNDATION_LAYERS = 20 + 1
